<ng-template #template>
    <div [class]="model.rootCss">
        <svc-search [model]="model.searchManager"></svc-search>
        <survey-content *ngIf="!!model.survey" [model]="model.survey"></survey-content>
    </div>
</ng-template>